/* tslint:disable */
/* eslint-disable */
/**
 * Agent service API
 * Service for credentials management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateAliasResponse,
} from '../models/index';
import {
    CreateAliasResponseFromJSON,
    CreateAliasResponseToJSON,
} from '../models/index';

export interface ConstructAliasRequest {
    user?: string;
    role?: string;
    org?: string;
    isMultisigParticipant?: boolean;
    isOrgAid?: boolean;
    alias?: string;
}

/**
 * 
 */
export class UtilControllerApi extends runtime.BaseAPI {

    /**
     * All string params should be encoded
     * Construct alias by user name, role in org and org name
     */
    async constructAliasRaw(requestParameters: ConstructAliasRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateAliasResponse>> {
        const queryParameters: any = {};

        if (requestParameters['user'] != null) {
            queryParameters['user'] = requestParameters['user'];
        }

        if (requestParameters['role'] != null) {
            queryParameters['role'] = requestParameters['role'];
        }

        if (requestParameters['org'] != null) {
            queryParameters['org'] = requestParameters['org'];
        }

        if (requestParameters['isMultisigParticipant'] != null) {
            queryParameters['isMultisigParticipant'] = requestParameters['isMultisigParticipant'];
        }

        if (requestParameters['isOrgAid'] != null) {
            queryParameters['isOrgAid'] = requestParameters['isOrgAid'];
        }

        if (requestParameters['alias'] != null) {
            queryParameters['alias'] = requestParameters['alias'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/agent/util/alias`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateAliasResponseFromJSON(jsonValue));
    }

    /**
     * All string params should be encoded
     * Construct alias by user name, role in org and org name
     */
    async constructAlias(requestParameters: ConstructAliasRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateAliasResponse> {
        const response = await this.constructAliasRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
